import { useContext } from 'react'
import { PassContext } from "../../pass-context"
import dataSelector from '../data-selector'
import { PassImage } from '/components/editor/pass-image'

const GoogleLogo = () => {

  const { classData, objectData, variables, passType } = useContext(PassContext)

  let logoUrl = getLogoImage({ classData, objectData, variables, passType })

  return <PassImage src={logoUrl} className="logo" />
}

export default GoogleLogo

const getLogoImage = ({ classData, objectData, variables, passType }) => {
  try {

    switch (passType) {
      case "generic": return dataSelector({ objectData, variables, path: "logo.sourceUri.uri" })
      case "flight": return dataSelector({ objectData:classData, variables, path: "flightHeader.carrier.airlineLogo.sourceUri.uri" })
      // Google allows transit in class data but we are only going to support object data
      case "transit": return dataSelector({ objectData, variables, path: "logo.sourceUri.uri" })
      case "eventTicket": return dataSelector({ objectData:classData, variables, path: "logo.sourceUri.uri" })
      case "giftCard": return dataSelector({ objectData:classData, variables, path: "programLogo.sourceUri.uri" })
      case "loyalty":return dataSelector({ objectData:classData, variables, path: "programLogo.sourceUri.uri" })
      case "offer": return  dataSelector({ objectData:classData, variables, path: "titleImage.sourceUri.uri" })
    }
  }
  catch (err) {
    console.error("Error destructuring logo path")
  }
}
